<div *ngFor="let dataGroup of chatdata.metadata;" class="row">
    <div class="col-6 display-grid m-b-15">
        <div>
            <div class="product-panel__bg1">
                <div class="product_panel">
                    <h4>{{dataGroup.table | slice:0:62}}{{dataGroup.table .length > 62 ? '...' : '' }}</h4>
                </div>
                <div class="product_panel_body">
                    <p class="p-b-10" *ngIf="dataGroup.id && dataGroup.id.length > 0">
                        <span>ID: {{dataGroup.id.join(', ')}}</span>
                    </p>

                </div>
            </div>
        </div>
    </div>
</div>